import { Handle, Position } from '@xyflow/react';
import { WorkflowHandlerID } from '../../workflow/ui';
import { TNodeProps } from '../types/node';
import { BaseNode } from './BaseNode';
import { SOURCE_HANDLE_CLASSNAME, TARGET_HANDLE_CLASSNAME } from './helpers';

export const ExclusiveSplitGatewayNode = (props: TNodeProps) => {
  return (
    <BaseNode {...props}>
      <Handle
        type="source"
        position={Position.Right}
        className={SOURCE_HANDLE_CLASSNAME}
        id={WorkflowHandlerID.SOURCE_RIGHT_TRUE}
        style={{
          top: '40%',
        }}
      />
      <Handle
        type="source"
        position={Position.Right}
        className={SOURCE_HANDLE_CLASSNAME}
        id={WorkflowHandlerID.SOURCE_RIGHT_FALSE}
        style={{
          top: '60%',
        }}
      />
      <Handle
        type="target"
        position={Position.Left}
        className={TARGET_HANDLE_CLASSNAME}
        id={WorkflowHandlerID.TARGET_LEFT}
      />
      <Handle
        type="source"
        position={Position.Bottom}
        className={SOURCE_HANDLE_CLASSNAME}
        id={WorkflowHandlerID.SOURCE_BOTTOM_TRUE}
        style={{
          left: '40%',
        }}
      />
      <Handle
        type="source"
        position={Position.Bottom}
        className={SOURCE_HANDLE_CLASSNAME}
        id={WorkflowHandlerID.SOURCE_BOTTOM_FALSE}
        style={{
          left: '60%',
        }}
      />
      <Handle
        type="target"
        position={Position.Top}
        className={TARGET_HANDLE_CLASSNAME}
        id={WorkflowHandlerID.TARGET_TOP}
      />
    </BaseNode>
  );
};
